export const DATASOURCES_GET_DATASOURCES = "users/get-data-sources";
